const productionCategories = ["1-voice", "1-voice A-list", "Special Production"];
const defaultProductionCategory = "1-voice";

export { productionCategories, defaultProductionCategory };
